import { useEffect, useState } from 'react'

export const useStepper = (items = []) => {
    const [steps, setSteps] = useState([])

    useEffect(() => { setItems(items) }, []);

    const setItems = (newItems = []) => {
        const newSelection = []

        for (let i = 0; i < newItems.length; i++)
            newSelection.push({id: newItems[i].id, label: newItems[i].label, selected: false})

        setSteps(newSelection)
    }

    const computeSelection = (selected = null, completed = false) => {
        const newSelection = []
        let isSelected = true

        for (let i = 0; i < items.length; i++) {
            let selectedMode = false
            let completedMode = false

            if (selected) {
                if (selected !== items[i].id && isSelected) {
                    completedMode = true
                    selectedMode = true
                } else if (selected === items[i].id && isSelected) {
                    isSelected = false
                    selectedMode = true
                    completedMode = (completed)
                }
            }

            newSelection.push({id: items[i].id, label: items[i].label, selected: selectedMode, completed: completedMode})
        }
        setSteps(newSelection)
    }

    return { steps, computeSelection, setItems }
}